module.exports = __webpack_public_path__ + "static/img/nedc.0aaf777.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo/nedc.jpg
// module id = zzak
// module chunks = 1